import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITransporterMember } from '../../../../../../models/transporter-member.model';
import { TransporterMemberService } from '../../../../../../services/transporter-member.service';
import { TransporterMemberAttributeFilter } from '../../../models/transporter-member-attribute-filter';

@Component({
  selector: 'jhi-transporter-member-filter',
  templateUrl: './transporter-member-filter.component.html',
  styleUrls: ['./transporter-member-filter.component.scss'],
})
export class TransporterMemberFilterComponent implements OnInit {
  @Input() filter!: TransporterMemberAttributeFilter;
  @Output() filterChange = new EventEmitter<TransporterMemberAttributeFilter>();
  transporterMembers!: ITransporterMember[];

  constructor(public commercialService: TransporterMemberService) {}

  ngOnInit(): void {
    this.getAllCommercials();
  }

  private getAllCommercials(): ITransporterMember[] {
    this.commercialService.querySales().subscribe(value => {
      if (value.body) {
        this.transporterMembers = value.body;
      }
    });
    return this.transporterMembers;
  }

  prepareAndEmit(filter: TransporterMemberAttributeFilter): void {
    const com = this.transporterMembers.find(it => it.id + '' === filter.tempValue);
    filter.secondValue = `${com?.firstName} ${com?.lastName}`;
    this.filterChange.emit(filter);
  }
}
